import axios from './apiClient'
import config from '../../config';

export function createSession(username, password) {
  return axios.post('/login?jwt=true', {username, password}, {
    headers: {
      "origin-service": "dashboard"
    }
  }).then((resp) => {
    return resp.data
  });
}

export function refreshJWT(refreshToken, updateSessionTimeout) {
  return axios.post(`login/jwt/refresh?updateSessionTimeout=${updateSessionTimeout}`, {refreshToken}, {
    headers: {
      "origin-service": "dashboard"
    }
  }).then((resp) => {
    return resp.data
  });
}

export function logout(refreshToken) {
  return axios.post('/logout', {refreshToken})
}

export function getLoginSSO(ssoToken) {
  return axios.get('/v5/singlesignon/authUserWithLoginToken?jwt=true', {params: {token: ssoToken}})
    .then(x => x.data)
}

/** @returns {Promise.<User>} */
export function getCurrentUser() {
  return axios.get('/user/info').then(response => response.data)
}

export function getCurrentUsersAccount() {
  return axios.get('/v5/currentAccount').then(response => response.data)
}

export function getAccountByID(id, shouldDisplaySanitizedData = false) {
  return axios.get(`/v5/accounts/${id}`, {params: {shouldDisplaySanitizedData}}).then(response => response.data);
}

export function getAllUsersAccounts() {
  return axios.get('/v5/accounts').then(response => response.data.accounts);
}

export function getCurrentBrandConfig() {
  return axios.get('/brand/config').then(response => response.data)
}

export function validatePasswordResetToken(token) {
  return axios.post('/password/validatePasswordResetToken', {pwResetToken: token}).then(() => {})
}

export function resetPassword(password, token) {
  return axios.post('/login/resetPassword', {password: password, token: token}).then(response => response.data)
}

export function forgotPasswordEmail(username) {
  return axios.get('/login/forgotPasswordEmail', {params: {username: username}}).then(response => response.data)
}

export function validateSession() {
  return axios.get('/login/validateToken').then(x => x.data.isValid)
}

export function extendSession() {
  return axios.post('/login/extend').then(x => x.data);
}

export function generateSSOToken(username) {
  return axios.get('/v5/singlesignon/generateLoginToken', {
    params: {username: username}
  });
}

export function presignDownload(url) {
  return axios.get('/dashboard/presign', { params: {url} });
}

/**
  * @typedef {object} User
  * @property {string} userId -
  * @property {string} username -
  * @property {string} usernameLowercase -
  * @property {string} email -
  * @property {string} phoneNumber -
  * @property {string} firstName -
  * @property {string} lastName -
  * @property {string} userType -
  * @property {string} accountId -
  * @property {string} billingAccountId -
  * @property {string[]} permissions -
  * @property {boolean} [enabled] -
  * @property [string] timezone -
  */
